import axios from "axios";

const token = import.meta.env.VITE_MAIN_API_TOKEN;

const msfAxios = axios.create({
  baseURL: import.meta.env.VITE_MAIN_API_URL,
  headers: {
    "X-Request-Agent": "gema-dashboard",
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  },
});

export async function getVolunteers(year) {
  try {
    const { data } = await msfAxios.get("/msf/volunteer", {
      params: year ? { year } : {},
    });
    return data;
  } catch (error) {
    console.log(error);
  }
}
